import { settings } from "../../app/settings";

export const checkPermission = (permissions, permission) => {
  if (settings.noAuth === true || !permission) {
    return true;
  }

  if (settings.usesCustomPermissionValidator) {
    return settings.permissionsValidator(permissions, permission);
  }

  return permissions?.isAdmin || permissions?.permissions?.includes(permission);
};

export const filterByPermissions = (resources, userPermissions) => {
  if (settings.noAuth === true) {
    userPermissions = {
      isAdmin: true,
    };
  }

  if (!userPermissions) return [];

  const list = [];

  resources.forEach(resource => {
    if (!checkPermission(userPermissions, resource.permission)) {
      return;
    }

    if (!resource.subMenu) {
      list.push(resource);
      return;
    }

    const hasAvailableSubmenus = resource.subMenu.some(subResource => {
      return subResource.isMenu && checkPermission(userPermissions, subResource.permission);
    });

    if (hasAvailableSubmenus) {
      resource.subMenu = filterByPermissions(resource.subMenu, userPermissions);
      list.push(resource);
    }
  });

  return list;
};
